var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('lazy-hydrate',{attrs:{"when-visible":""}},[_c('cms-util-text',{attrs:{"content":_vm.text,"anchor":_vm.anchor}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }